module.exports = __webpack_public_path__ + "img/Bilde4.6b68d18a.jpg";